export default {
  path: '/travel-documents/prl-cargo/:id',
  name: 'PrlCargoDetailsView',
  component: () => import(/* webpackChunkName: "fleet" */ '../views/PrlCargoDetailsView.vue')
}
